"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const model_1 = require("@cargoticcom/model");
const social_1 = require("../social");
const deserializeVehicleActivity = (data) => {
    if (data.type === model_1.VehicleActivityType.VEHICLE_COMMENTARY) {
        return {
            ...data,
            commentary: social_1.deserializeCommentary(data.commentary)
        };
    }
    return {
        ...data,
        createdAt: new Date(data.createdAt)
    };
};
exports.default = deserializeVehicleActivity;
